import {
  Component,
  OnDestroy,
  computed,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { CampaignPage } from '@fmnts/api/next';
import { CustomStyleService } from '@fmnts/common/browser';
import { isNonEmptyString } from '@fmnts/core';
import {
  DeclarativeFormComponent,
  DeclarativeFormsModule,
  ValidationStrategy,
} from '@fmnts/declarative-forms';
import { FormActionsComponent } from '@formunauts/shared/declarative-forms/feature';
import { provideDeclarativeSupporterFeedbackForm } from './declarative-supporter-feedback-form.provider';

export interface FormActionEvent {
  action: string;
  formComponent: DeclarativeFormComponent;
}

@Component({
  selector: 'supporter-feedback-form-page',
  templateUrl: './form-page.component.html',
  imports: [DeclarativeFormsModule, FormActionsComponent],
  providers: [provideDeclarativeSupporterFeedbackForm()],
})
export class FormPageComponent implements OnDestroy {
  private readonly customStyle = inject(CustomStyleService);

  readonly page = input.required<CampaignPage>();
  readonly pages = input.required<CampaignPage[]>();
  readonly validationStrategy = input(ValidationStrategy.OnSubmit);

  readonly storeId = input<string[]>([]);
  readonly style = input<string | undefined>(undefined);

  constructor() {
    effect(() => {
      const style = this.style();

      this.customStyle.removeGlobalStyle();
      if (isNonEmptyString(style)) {
        this.customStyle.setGlobalStyle(style);
      }
    });
  }

  readonly action = output<FormActionEvent>();

  /**
   * Emits when the validation result changes.
   * Only emits when `ValidationStrategy` is set to `OnChange`.
   */
  readonly isValidChanged = output<boolean>();

  protected readonly formValuesStoreId = computed(() =>
    ['public', ...this.storeId()].join('_'),
  );

  ngOnDestroy(): void {
    this.customStyle.removeGlobalStyle();
  }

  handleAction(action: string, formComponent: DeclarativeFormComponent): void {
    this.action.emit({ action, formComponent });
  }

  handleIsValidChanged(isValid: boolean): void {
    this.isValidChanged.emit(isValid);
  }
}
